export const ActionTypes = {
  GET_PRODUCTS: "GET_PRODUCTS",
  ADD_TO_CART: "ADD_TO_CART",
  IS_LOADING: "IS_LOADING",
  REMOVE_FROM_CART: "REMOVE_FROM_CART",
  CLEAR_CART: "CLEAR_CART",
  IS_LOGGED: "IS_LOGGED",
  FILTER_PRODUCTS: "FILTER_PRODUCTS",
  CLEAR_CATEGORY: "CLEAR_CATEGORY",
  UPDATE_CART: "UPDATE_CART",
};
